import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

function getTextLineHeight(element) {
  const raw = document.defaultView.getComputedStyle(element, null).lineHeight;
  if (!raw) return 0;
  // the raw is in a weird format like this 10px or 10.5px
  const lineHeight = Number(raw.replace('px', ''));

  return lineHeight;
}

function getLineCount(element) {
  const lineHeight = getTextLineHeight(element);
  const { offsetHeight } = element;

  return Math.ceil(offsetHeight / lineHeight);
}

const ExpandableText = ({
  expandedText = 'Read Less',
  collapsedText = 'Read More',
  children,
  maxLines,
  truncateTo,
}) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const textContainerRef = useRef(null);

  useEffect(() => {
    const lineCount = getLineCount(textContainerRef.current);
    const showButtonsCond = lineCount > maxLines;

    setShowButton(showButtonsCond);
    setIsTruncated(showButtonsCond);
  }, [maxLines, children]);

  useEffect(() => {
    if (isTruncated) {
      const lineHeight = getTextLineHeight(textContainerRef.current);
      const lines = getLineCount(textContainerRef.current);
      const lineMultiplier = truncateTo < lines ? truncateTo : lines;

      textContainerRef.current.style.height = `${lineHeight * lineMultiplier}px`;
      textContainerRef.current.style.overflow = 'hidden';
    } else {
      // expand
      textContainerRef.current.style.height = `${textContainerRef.current.scrollHeight}px`;
      textContainerRef.current.style.overflow = 'none';
    }
  }, [isTruncated, truncateTo]);


  const toggleShowContent = () => {
    setIsTruncated(!isTruncated);
  };

  return (
    <div>
      <div
        ref={textContainerRef}
        className="ExpandableText-text"
      >
        {children}
      </div>
      <div>
        { showButton
          && (
          <button
            id="read-more-button"
            type="button"
            className="inspect-button inspect-expand-button"
            onClick={toggleShowContent}
          >
            {isTruncated ? collapsedText : expandedText}
          </button>
          )
        }
      </div>
    </div>
  );
};

ExpandableText.propTypes = {
  text: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  maxLines: PropTypes.number,
  truncateTo: PropTypes.number,
};

ExpandableText.defaultProps = {
  maxLines: 10,
  truncateTo: 5,
};

export default ExpandableText;
